var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHandholdingkey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 6H2.5V1.25H0.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 5.25023H3.5C4 6.75023 5.5 7.25023 6.25 7.25023L8.2875 9.60023C8.37198 9.70094 8.47549 9.78401 8.5921 9.84469C8.70871 9.90536 8.83614 9.94244 8.9671 9.95382C9.09806 9.9652 9.22998 9.95065 9.35531 9.91099C9.48064 9.87134 9.59692 9.80737 9.6975 9.72273V9.72273C9.90016 9.55218 10.0269 9.30819 10.0498 9.04432C10.0728 8.78044 9.99015 8.51823 9.82 8.31523L8 6.25023V5.25023C8 5.11762 8.05268 4.99045 8.14645 4.89668C8.24021 4.80291 8.36739 4.75023 8.5 4.75023H9.25L10.25 6.00023V8.87523C10.2507 9.10709 10.3431 9.32927 10.507 9.49322C10.671 9.65717 10.8931 9.74957 11.125 9.75023V9.75023C11.3569 9.74957 11.579 9.65717 11.743 9.49322C11.9069 9.32927 11.9993 9.10709 12 8.87523V5.34023C12 5.11957 11.9271 4.9051 11.7925 4.73023L9.875 2.25023C9.75727 2.09728 9.60572 1.97368 9.43222 1.8891C9.25873 1.80452 9.06801 1.76127 8.875 1.76273H2.75",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 9.5V12",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.54 14.1499L7.5 16.7499H6.25L7.3775 15.2499H7.75V14.7499L8.6675 13.5324C8.46022 13.2391 8.35743 12.8848 8.37564 12.5261C8.39385 12.1675 8.53199 11.8254 8.76791 11.5546C9.00382 11.2839 9.32384 11.1002 9.67662 11.0331C10.0294 10.966 10.3945 11.0193 10.7133 11.1846C11.0322 11.3498 11.2863 11.6173 11.4349 11.9442C11.5835 12.2711 11.618 12.6385 11.5329 12.9873C11.4477 13.3362 11.2479 13.6464 10.9654 13.868C10.6829 14.0897 10.3341 14.2101 9.975 14.2099C9.82801 14.2088 9.68178 14.1887 9.54 14.1499Z",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76 14.195L9.6875 15.0775L10.185 15.575L10.7175 15.045L12.5 16.75L15.25 14L13.5 12.25L14.075 11.685L13.5775 11.1875L11.25 11.3775",
    stroke: "#464646",
    strokeWidth: 0.7,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandholdingkey);
export default __webpack_public_path__ + "static/media/hand holding key.e827578e.svg";
export { ForwardRef as ReactComponent };